import React from 'react';
import { Tooltip } from "react-tooltip";

const DoterraTooltip = ({ ...props}) => {
    return (
        <Tooltip className="doterra-tooltip" variant="light" {...props}/>
    );
};

export default DoterraTooltip;